import { Box, Typography } from '@mui/material';

import {
  selectActiveChapterId,
  selectActiveEpisodeId,
  selectEpisodeCompliance,
  selectPlayerProgress,
  selectPlayerSeekToPosition,
  useAppSelector,
  useFetchChapterQuery,
} from '@/store';
import { convertMsToHHMMSS } from '@/utils';

export const ProgressInfo = () => {
  const activeChapterId = useAppSelector(selectActiveChapterId)!;
  const activeEpisodeId = useAppSelector(selectActiveEpisodeId);
  const compliance = useAppSelector(state =>
    selectEpisodeCompliance(state, activeEpisodeId),
  );
  const { chapterDuration } = useFetchChapterQuery(
    {
      chapterId: activeChapterId,
      compliance,
    },
    {
      selectFromResult: result => ({
        chapterDuration: result.data?.duration,
      }),
    },
  );

  const progress = useAppSelector(selectPlayerProgress);
  const seekToPosition = useAppSelector(selectPlayerSeekToPosition);
  const position = progress.position ?? seekToPosition ?? 0;

  const formattedCurrentPosition = convertMsToHHMMSS(position * 1000);
  const formattedChapterDuration = convertMsToHHMMSS(
    (chapterDuration ?? 0) * 1000,
  );

  return (
    <Typography
      variant="body3"
      sx={{
        color: 'white',
        mr: {
          xs: 1,
          sm: 2.5,
        },
      }}>
      {formattedCurrentPosition}
      <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
        {' '}
        / {formattedChapterDuration}
      </Box>
    </Typography>
  );
};
